import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export function Modal({
  open = true,
  onExited,
  onOverlayClick,
  children,
  className = '',
  ...props
}) {
  const [shouldRender, setShouldRender] = useState(open);
  const exitTimerRef = useRef(null);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      if (exitTimerRef.current) {
        clearTimeout(exitTimerRef.current);
        exitTimerRef.current = null;
      }
      return undefined;
    }

    if (!shouldRender) {
      return undefined;
    }

    exitTimerRef.current = setTimeout(() => {
      setShouldRender(false);
      onExited?.();
      exitTimerRef.current = null;
    }, 220);

    return () => {
      if (exitTimerRef.current) {
        clearTimeout(exitTimerRef.current);
        exitTimerRef.current = null;
      }
    };
  }, [open, onExited, shouldRender]);

  if (!shouldRender) return null;

  return createPortal(
    <div
      className={[
        'ci-modal-overlay',
        open ? 'ci-modal-overlay--open' : 'ci-modal-overlay--closing',
      ].join(' ')}
      onClick={onOverlayClick}
    >
      <div
        className={[
          'ci-modal',
          className,
          open ? 'ci-modal--open' : 'ci-modal--closing',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        {...props}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
